<div class="med-warship-banner">
  <div class="med-warship-banner__wrapper">
    <div class="med-warship-banner__content">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="med-warship-banner__nav">
    <med-btn
      *ngIf="linkBanner"
      mode="icon"
      class="med-warship-banner__btn"
      (click)="linkClick()"
    >
      <med-icon-arrow-up-right size="16"></med-icon-arrow-up-right>
    </med-btn>

    <med-btn
      mode="icon"
      class="med-warship-banner__btn"
      (click)="close.emit()"
    >
      <med-icon-x size="16"></med-icon-x>
    </med-btn>
  </div>
</div>
